import React, {useEffect, useRef, useState} from "react";
import dayjs from "dayjs";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import PropTypes from "prop-types";
import Cleave from 'cleave.js/react';
import classnames from "classnames";

import calendarIcon from "apps/QuoterApp/assets/images/Calendar Icon.svg";

import useOutsideClick from "shared/hooks/useOutsideClick";

import 'shared/components/DatePicker/styles.scss';


// TODO: MOVE TO COMMON MODULE
function isValidDate(date, format) {
    try {
        return dayjs(date, format).format(format) === date;
    } catch (e) {
        return false;
    }
}

const DATE_FORMAT = "MM/DD/YYYY";

function DatePicker({value: propValue, required, onChange}) {
    const [value, setValue] = useState();
    const [rawValue, setRawValue] = useState();
    const [showCalendar, setShowCalendar] = useState(false);
    const [cleaveRef, setCleaveRef] = useState();
    const [validate, setValidate] = useState(false);

    useEffect(() => {
        setValue(propValue);
    }, [propValue]);

    const calendarRef = useRef(null);
    useOutsideClick(calendarRef, () => setShowCalendar(false));

    const onChangeInput = event => {
        const dateStr = event.target.value.toString();
        setRawValue(dateStr);

        if (dateStr && isValidDate(dateStr, DATE_FORMAT)) {
            const date = dateStr && dayjs(dateStr);

            onChange(date);
            setValue(date);
        } else {
            onChange(undefined);
            setValue(undefined);
        }
    };
    const onChangeCalendar = date => {
        setShowCalendar(false);
        cleaveRef.setRawValue(
            dayjs(date).format(DATE_FORMAT),
        );
    };

    const valueStr = value && dayjs(value).format(DATE_FORMAT);
    useEffect(() => {
        cleaveRef && cleaveRef.setRawValue(valueStr);
    }, [cleaveRef, valueStr]); // Use string instead of instance to check equality

    let error = undefined;
    if (required && !rawValue) {
        error = "Value required";
    } else if (rawValue && !isValidDate(rawValue, DATE_FORMAT)) {
        error = "Enter a valid date";
    }

    return <>
        <div className={"DatePicker"}>
            <Cleave
                className={classnames({
                    "Valid": validate && !error,
                    "Error": validate && error,
                })}
                onInit={setCleaveRef}
                placeholder="MM/DD/YYYY"
                options={{
                    date: true,
                    delimiter: '/',
                    datePattern: ['m', 'd', 'Y'],
                }}
                onChange={onChangeInput}
                onBlur={() => setValidate(true)}
            />
            <button
                className={"DatePicker__CalendarButton"}
                onClick={() => setShowCalendar(!showCalendar)}
            >
                <img
                    src={calendarIcon}
                    alt={"Calendar"}
                />
            </button>
            {showCalendar && (
                <div ref={calendarRef} className={"DatePicker__Calendar"}>
                    <Calendar
                        value={value && value.toDate()}
                        onChange={onChangeCalendar}
                    />
                </div>
            )}
        </div>
        <div className={"ErrorList"}>
            {validate && error}&nbsp;
        </div>
    </>;
}

DatePicker.propTypes = {
    value: PropTypes.instanceOf(dayjs),
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
};

DatePicker.defaultProps = {
    required: false,
};

export default DatePicker;
